var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _circle, _circle2, _circle3, _circle4, _circle5, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle13, _circle14, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateEstimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "03431522-47b9-4239-bf4c-9446bb50bb61",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1027.35,
    height: 783.97,
    viewBox: "0 0 1027.35 783.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4f43e098-a778-42ef-b33c-7c47f8946c90",
    x1: 940.91,
    y1: 792.08,
    x2: 940.91,
    y2: 388.7,
    gradientTransform: "translate(-77.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672.88,182c-64.72-2.25-126.36-23.14-185.23-46S370.49,87.82,307.32,75.7c-40.63-7.79-87.09-8.89-119.83,12.89-31.5,21-41.68,57.15-47.16,90.73-4.11,25.26-6.53,51.85,4.75,75.5,7.83,16.42,21.74,30.22,31.36,45.94C209.9,355.48,186.25,423,150,476.39c-17,25.07-36.74,49-49.87,75.66s-19.2,57.25-7.72,84.47c11.39,27,38.52,47.24,67.91,61.49,59.68,29,130,37.23,198.61,41.92,151.82,10.39,304.46,5.89,456.68,1.39,56.34-1.67,112.92-3.36,168.35-12.07,30.77-4.83,62.55-12.51,84.89-31,28.36-23.53,35.39-63.37,16.39-92.88-31.88-49.49-120-61.78-142.31-114.89-12.27-29.24.33-61.8,18.15-88.92,38.24-58.16,102.33-109.19,105.71-175.67,2.32-45.66-28.49-91.39-76.13-113-49.94-22.64-119.18-19.79-156,17.69C796.68,169.13,730,184,672.88,182Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.79,
    cy: 726.58,
    rx: 370.98,
    ry: 27.58,
    fill: "#0964eb",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.26,695.27s21-3.36,33.6,11.49c0,0-9.24,7.28-29.12-2.8Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377,695s-13.39,16.52-6.82,34.85c0,0,10.92-4.38,12.11-26.64Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365,667.83s8.4-15.4,42,6.16c0,0-4.48,10.36-19.32,9.52S368.9,676,365,667.83Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.81,666.72s-17.43-2-19.12,37.91c0,0,11.05,2.29,18.9-10.33S367.2,674.6,362.81,666.72Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352.66,634.9s9.8-27.16,45.36-7.84c0,0-8.12,24.92-41.72,17.08Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73,594.3s18.49-27.45,51.25-2c0,0-11.48,25.76-48.45,11.76Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.81,555.65s21.57-25.2,54.05,0c0,0-20.44,22.12-54.05,6.44Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.45,518.13s21.85-26.32,52.93-1.4c0,0-24.64,23.24-52.93,7.56Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41,484.81s23-33.89,52.09-10.92c0,0-24.64,29.12-52.09,17.36Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73,445.88s24.37-33.6,52.65-7.84c0,0-28.84,29.13-52.65,14Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M349.86,411.09s28.84-31.57,54-19c0,0-30.06,33.53-55.26,27.37Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M359.94,378.12s33.32-38.64,52.64-25.76c0,0-24.52,30-55,33Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.49,339.87s29.13-31.58,50.41-23.74c0,0-24.92,32.76-54.32,33.6Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M387.66,304.09s32.2-30.25,46.2-24.93c0,0-23.24,33.61-47.6,31.65Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400.54,271s27.72-36.12,42.84-33.32c0,0-16.8,32.2-42.84,37Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M414.52,226.5s24.5-27.7,37.73-27.63c0,0-19.34,37-38.74,36.66Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M422.8,196.84l23.66-57.69s1.19,52.15-26.67,68.39Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M432.41,133.22s3.92-48.16,1.4-52.08c0,0,16.92,40-1.57,73.36Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M351.74,634.25s-24.54-15.21-40.43,22c0,0,21.84,14.49,43.31-12.51Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M341,592.75s-30.1-13.73-44.71,25.12c0,0,23.26,16,47.45-15.3Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41,558s-21.56-25.2-54,0c0,0,20.44,22.12,54,6.44Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M333.72,518.13s-21.84-26.32-52.93-1.4c0,0,24.65,23.24,52.93,7.56Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41,485.77s-15.32-38-48.62-21.63c0,0,18,33.65,47.27,27.92Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M343.66,445.69s-15.22-38.61-49-20.7c0,0,20.68,35.39,47.5,26.67Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1,411.29s-6-42.33-34-46.12c0,0,5.93,44.64,30.22,53.75Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M360.65,378.19s-2.34-51-25.49-52.77c0,0,.78,38.71,22.88,60Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M376.89,338.41s-6.91-42.41-29-47.6c0,0,2.74,41.08,26.82,58Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M390.28,304.39s-.24-44.17-13.73-50.67c0,0-8.38,40,9.82,56.31Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M401.57,270.55s-1.89-45.49-15.87-51.9c0,0-4.79,36,13.77,54.88Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M416.47,230.12s-.09-37-10.06-45.67c0,0-9.93,40.53,4.85,53.12Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62,195l-9.7-61.59s-13.19,50.46,10.17,72.69Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M423.52,133.81s-24.92-41.4-24.41-46c0,0,2.65,43.39,34,65Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M426.44,121.58S402.92,62.78,392.28,58c0,0,33.6,17.08,36.12,61.88Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M413.38,235.88l-1.6-.5c19.85-64.72,24.8-106,13.94-116.34l1.16-1.22C438.39,128.74,433.72,169.56,413.38,235.88Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M358.73,387.39l-2.38-.84c2.1-5.93,4.38-11.95,6.76-17.88C383.83,317,401.46,269,412.77,232.11l2.07-1C403.51,268,386.19,317.9,365.45,369.61,363.08,375.51,360.82,381.49,358.73,387.39Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M408.81,743.72c-.32-.36-32.5-36.58-54.92-98.44a364.42,364.42,0,0,1-21.7-112.77c-1.53-48.13,8.56-101.88,25.87-150.69l1.88,2.2C321.1,493.58,336.53,587.47,357,644c22.19,61.29,54,97.12,54.31,97.48Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M268.6,735.82s-38.05-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.06-2,3.9-1.31a17.51,17.51,0,0,0,4.13.2,8.62,8.62,0,0,0,5.06-2.08h0s10.69-4.42,14.85-21.9c0,0,3.08-3.81,2.95-4.79l-6.42,2.74s2.2,4.63.47,8.48c0,0-.21-8.31-1.44-8.12-.25,0-3.34,1.61-3.34,1.61s3.78,8.07.93,13.93c0,0,1.08-9.94-2.1-13.35l-4.52,2.64s4.41,8.33,1.42,15.13c0,0,.76-10.43-2.37-14.49l-4.1,3.2s4.14,8.21,1.62,13.85c0,0-.33-12.14-2.51-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.11,0,0-1.08-8.09-2-8.13,0,0-3.57,5.36-3.94,9a19.46,19.46,0,0,1,3.07-9.54,10.71,10.71,0,0,0-5.46,2.83s.55-3.79,6.34-4.12c0,0,3-4.07,3.74-4.32,0,0-5.76-.48-9.25,1.07,0,0,3.07-3.57,10.31-2l4-3.3s-7.58-1-10.8.11c0,0,3.7-3.16,11.89-.86l4.4-2.63s-6.46-1.39-10.32-.89c0,0,4.07-2.19,11.61.18l3.15-1.41s-4.74-.93-6.12-1.08-1.47-.53-1.47-.53a16.39,16.39,0,0,1,8.9,1S268.71,736.24,268.6,735.82Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M158,748.19s-38-2.29-33.55,24.37c0,0-.9,4.71,3.37,6.85,0,0,.07-2,3.91-1.31a17,17,0,0,0,4.13.2,8.56,8.56,0,0,0,5.05-2.08h0s10.7-4.42,14.86-21.9c0,0,3.07-3.81,3-4.79l-6.42,2.74s2.2,4.63.47,8.48c0,0-.21-8.31-1.44-8.12-.25,0-3.34,1.61-3.34,1.61s3.78,8.07.93,13.93c0,0,1.08-9.94-2.11-13.35l-4.52,2.64s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.09,3.2s4.14,8.21,1.62,13.85c0,0-.33-12.14-2.51-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.11,0,0-1.08-8.09-2-8.13,0,0-3.56,5.36-3.94,9a19.52,19.52,0,0,1,3.08-9.54,10.76,10.76,0,0,0-5.47,2.83s.56-3.79,6.35-4.12c0,0,3-4.07,3.74-4.31,0,0-5.76-.49-9.25,1.06,0,0,3.07-3.57,10.31-2l4-3.3s-7.58-1-10.8.11c0,0,3.7-3.16,11.89-.86l4.4-2.63s-6.47-1.39-10.32-.89c0,0,4.07-2.19,11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.51,16.51,0,0,1,8.9,1S158.08,748.61,158,748.19Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M219.64,777.23s-38-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.07-2,3.9-1.31a17.57,17.57,0,0,0,4.14.2,8.62,8.62,0,0,0,5.05-2.08h0s10.69-4.42,14.85-21.9c0,0,3.08-3.81,3-4.79l-6.42,2.74s2.19,4.63.47,8.48c0,0-.21-8.31-1.45-8.12-.25,0-3.33,1.61-3.33,1.61s3.77,8.06.92,13.93c0,0,1.08-9.94-2.1-13.35l-4.52,2.64s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.1,3.2s4.15,8.21,1.62,13.85c0,0-.33-12.14-2.5-13.06,0,0-3.59,3.16-4.13,4.46,0,0,2.84,6,1.07,9.11,0,0-1.08-8.09-2-8.13,0,0-3.57,5.36-3.94,9a19.46,19.46,0,0,1,3.07-9.54,10.71,10.71,0,0,0-5.46,2.83s.55-3.79,6.35-4.12c0,0,2.94-4.07,3.73-4.32,0,0-5.76-.48-9.25,1.07,0,0,3.08-3.57,10.31-1.95l4-3.3s-7.58-1-10.8.11c0,0,3.71-3.16,11.89-.86l4.41-2.63S200.86,781.5,197,782c0,0,4.06-2.19,11.61.18l3.14-1.41s-4.73-.93-6.12-1.08-1.46-.53-1.46-.53a16.39,16.39,0,0,1,8.9,1S219.75,777.65,219.64,777.23Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#0964eb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.66,
    cy: 753.23,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.84,
    cy: 753.23,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 699.95,
    cy: 779.42,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000.43,
    cy: 713.79,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.07,
    cy: 710.95,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.44,
    cy: 723.72,
    rx: 26.93,
    ry: 4.55,
    fill: "#0964eb",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 302.74,
    y: 79.74,
    width: 431.35,
    height: 641.38,
    rx: 9.8,
    ry: 9.8,
    fill: "#3a3768"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 342.22,
    y: 134.87,
    width: 357.73,
    height: 126.09,
    rx: 29.21,
    ry: 29.21,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 344.52,
    y: 137.33,
    width: 352.31,
    height: 121.95,
    rx: 10.2,
    ry: 10.2,
    fill: "#e6e8ec"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 354.68,
    y: 313.48,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 441.63,
    y: 313.48,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 528.58,
    y: 313.48,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 315.16,
    width: 71.14,
    height: 79.04,
    rx: 28.84,
    ry: 28.84,
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 313.48,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    fill: "#0964eb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 354.68,
    y: 400.43,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 441.63,
    y: 400.43,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 528.58,
    y: 400.43,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 354.68,
    y: 496.41,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 441.63,
    y: 496.41,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 528.58,
    y: 496.41,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 528.58,
    y: 592.39,
    width: 71.14,
    height: 79.04,
    rx: 10.79,
    ry: 10.79,
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 402.11,
    width: 71.14,
    height: 79.04,
    rx: 28.84,
    ry: 28.84,
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 400.43,
    width: 71.14,
    height: 79.04,
    rx: 11.3,
    ry: 11.3,
    fill: "#0964eb"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 400.43,
    width: 71.14,
    height: 79.04,
    rx: 11.3,
    ry: 11.3,
    opacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 354.68,
    y: 592.39,
    width: 158.09,
    height: 79.04,
    rx: 10.04,
    ry: 10.04,
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 608.75,
    y: 496.41,
    width: 77.91,
    height: 175.03,
    rx: 11.66,
    ry: 11.66,
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 649.87,
    y: 237.98,
    width: 31.14,
    height: 3.37,
    fill: "#0964eb"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 604.28,
    y: 237.98,
    width: 31.14,
    height: 3.37,
    fill: "#0964eb"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 558.68,
    y: 237.98,
    width: 31.14,
    height: 3.37,
    fill: "#0964eb"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 513.09,
    y: 237.98,
    width: 31.14,
    height: 3.37,
    fill: "#0964eb"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M966.19,532.56c3.21-10.8,0-21.6,0-21.6V500.77s3.67-19.92-12.71-32.7l-10.86-9.58s-6.09-5.23-7.86-5.56a8,8,0,0,0-1-.15l-.32-.19a32.69,32.69,0,0,1-2.38-5,4.63,4.63,0,0,0,3.87-1.32,5,5,0,0,0,.91-1.53h0c.63-1.41.74-3.12,1.27-4.62a11,11,0,0,1,2-3.32c-.11.18-.23.35-.33.54,1.54-1.92,3.55-3.56,5-5.58a12.51,12.51,0,0,0,.79-1.25c-.06.09-.14.17-.21.26,2-3.21,2.61-7.1,3.19-10.85a9.76,9.76,0,0,0,.06-3.88,14.13,14.13,0,0,0-1.08-2.46c-2.36-4.87-2.32-11-6.09-14.89-2.84-2.91-7.14-3.8-11.19-4.3s-8.31-.79-11.79-2.91a12.44,12.44,0,0,0-3.19-1.75,2.62,2.62,0,0,0-3.13,1.16,2.06,2.06,0,0,1-.42.85,1.36,1.36,0,0,1-1.2.07l-5.39-1.44.06.27-.14,0,.2.85a.46.46,0,0,1,.51.29l-.87,1.34a13.51,13.51,0,0,1-4.86-1,1.13,1.13,0,0,0,0,.26l-.08,0c-.1,1.52,1.63,2.51,2.16,3.94a3,3,0,0,1,0,1.93,4.23,4.23,0,0,1-1,1.54c-1.91,1.89-4.36,1.52-6.56,2.71a1.42,1.42,0,0,0-.8.89.65.65,0,0,0-.07.49,1.16,1.16,0,0,0,.45.56,10,10,0,0,0,2.09,1.3c-.22.2-.43.4-.63.61a24.1,24.1,0,0,0,8.33,39.32c.08.42.14.85.2,1.3,0,.05,0,.08,0,.13l.06.58-7.26,3.09a5.78,5.78,0,0,1-5.2-3.35c-1.69-3.49-7.66,0-7.66,0s-18.21-1.36-25,2c0,0-10.87-4.56-12.4-4.87s-3.82-1.52-4.89-1.21-2.45-2-3.22-1.83-1.07-1.52-3.52-2.13-3.37.16-6.12-2.58-25.11-13.54-25.11-13.54L792.76,415l-10.71-8.52-.19.35c-.07-.25-.14-.51-.21-.79a102.59,102.59,0,0,0-4-12.49c-.69-1.65-1-3.73-1.93-2.63-.57.66-1.54-.79-3-1.77a2.53,2.53,0,0,0-3.77,1.1h0c-8.34,13.08-11.33,14-6.5,18.81,4.31,4.27,7.17,8,10.68,9.18l.42.13a.45.45,0,0,1-.23,0l20.36,24.34s14.69,12.78,24.8,16.88,9.33,5.33,9.33,5.33,30.62,15.51,35.36,15.21,3.83,31.79,1.84,37-5.2,42.59-5.2,42.59-3.07,7.91.15,13.38c0,0,.71,10.48.07,13-2.79,4.3-6.77,11.6-7.42,19.11,0,.4-.08.77-.12,1.16a2.7,2.7,0,0,1-.72.59l.68-.2a38.5,38.5,0,0,1-2,9.18A37.31,37.31,0,0,0,847.92,629v24.16l-2,15s-2.45,11.35,0,14a6.48,6.48,0,0,1,1.34,4.66,8.68,8.68,0,0,0,1.56,5.44,4.07,4.07,0,0,1,1,3.49c-.81,2.63,1.2,30.62,1.2,30.62s-.59,7.71-1.4,8.12,1.4,8.92,1.4,8.92-8.27,6.9-6.16,10.55l2.11,3.24-.56.55-.34.35a3.26,3.26,0,0,0-2.11-.4,80.62,80.62,0,0,1-8.32,7.41c-3.73,2.69-13.88,6.59-13.88,6.59l-8,.65h-.15s-3.83-.36-1.68,5.57,21.37,4.11,21.37,4.11l11.22-1.77s20,.1,25.73-1.17c2.39-.53,3-1.81,2.8-3.1l0,0-.06-.06a8,8,0,0,0-1.64-3.35,1.28,1.28,0,0,0-.14-.18l.36-4.1c8.49-4.89-2.4-14.51-2.4-14.51s3.73-8.11,5.64-10.74,1.91-41.38,1.91-41.38,1-14-1.63-17.24a5.83,5.83,0,0,1,2.86-5.27c1.89-1.29,7.6-19.06,12.08-33.81l2.82,17.38s-.61,8.32,1.22,10.75a4.14,4.14,0,0,1,.76,3.24,14.6,14.6,0,0,0,.41,7,4.63,4.63,0,0,0,1.49,2.5c1.63.81,1.73,3.7,2.34,4.31s4.39-.86,4.59,1.37a50.49,50.49,0,0,1,0,5.88l1.23,36.1s-2,3-2.45,11c-.17,3.41-.81,5.35-1.47,6.46a3.31,3.31,0,0,0,.3,3.88l.35.41-1.51,1.16a3.33,3.33,0,0,0-.94,4.11,3.23,3.23,0,0,0-.93,3.5,2.44,2.44,0,0,0,.26.57,5.68,5.68,0,0,0-3.05,1.51,25,25,0,0,1-5.39,5.42,103.71,103.71,0,0,0-8.59,7.36,12.34,12.34,0,0,1-5,4,8.25,8.25,0,0,1-1.51.45c-4,.82-2.75,5,.51,5.69s14.08,4,22.5,2.07c0,0,2.5,1,6.17-.86S916,786.47,916,786.47s4.59,0,5.21-1.82a7.14,7.14,0,0,0,.26-1.78l.13-.13-.12-.11a24.26,24.26,0,0,0-.31-4.07c-.12-.7-.25-1.32-.37-1.82-.39-1.52-1.12-3.49-1.43-4.32a1.53,1.53,0,0,0,.14-.21c1.75-3-1.16-10.12-1.16-10.12A19.4,19.4,0,0,1,921.8,758c1.63-1.22,5.92-32.86,5.92-32.86s-.21-8.11,2-11.76-3.06-25.75-3.06-25.75-2.25-5.07-1.43-6.9-.82-8.52-.82-8.52v-8a8.84,8.84,0,0,0-.47-2.8c-.63-1.88-1.56-5.49-.55-8.08,1.43-3.65,4.69-26.16,4.69-26.16s-2.55-9.93,1.19-17.84a15.54,15.54,0,0,1,1-1.83c2.77-4.35,1.94-12.08.57-18.31-.2-1-.43-1.9-.66-2.77-.09-.38-.19-.74-.29-1.1l.44-.18s0-.59.14-1.6a11.24,11.24,0,0,0,7.36-5.09s9.34-10.5,17.6-14.91,8.88-10.8,8.88-10.8c-1.22-2.13,2.19-10.8,2.19-10.8Zm-32.55-79.63h0Zm5.61,93.63-8.84,10.25,0-.06c-2.3-3.2,2.14-10.35,2.14-10.35L939.9,530c-.06,2.1-.32,4-1,4.83-2,2.74,3.68,7.31,3.68,7.31C939.55,542.15,939.25,546.56,939.25,546.56Z",
    transform: "translate(-86.32 -58.02)",
    fill: "url(#4f43e098-a778-42ef-b33c-7c47f8946c90)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M783.61,412.17l-4.83,9.37a19,19,0,0,1-4.49-.94,17,17,0,0,1-10.55-9.12c-4.31-9.52,2.82-15.67,6.14-17.49s6.41-3.89,8.9,2.08a103.26,103.26,0,0,1,3.91,12.41C783.27,410.67,783.61,412.17,783.61,412.17Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#cc818c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M937,460.91l-7.71,11.48s-36.43,17.38-29.47-3c3.06-9,3.42-15.57,2.87-20.12,0-.05,0-.08,0-.13-.72-5.69-2.86-8.16-2.86-8.16s35.51-18.18,30.22-5.75a17.12,17.12,0,0,0-1.25,8.18,27.88,27.88,0,0,0,3.82,11.35A37.71,37.71,0,0,0,937,460.91Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#cc818c"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M925.91,688.32s5.24,22,3,25.59-2,11.69-2,11.69-4.23,31.44-5.84,32.64a19.21,19.21,0,0,0-3.43,4s2.88,7.12,1.15,10.06a2.44,2.44,0,0,1-1.15,1c-2.7,1.14-12.68-3.92-18.36-7a3.24,3.24,0,0,1-.58-5.28,3.3,3.3,0,0,1,.92-4.08l1.5-1.16-.35-.41a3.31,3.31,0,0,1-.3-3.86c.65-1.09,1.28-3,1.45-6.41.41-7.86,2.42-10.88,2.42-10.88l-1.21-35.88a49.78,49.78,0,0,0,0-5.84c-.2-2.21-3.93-.75-4.53-1.36s-.71-3.47-2.32-4.28a4.59,4.59,0,0,1-1.46-2.49,14.39,14.39,0,0,1-.41-7,4.13,4.13,0,0,0-.75-3.22c-1.81-2.42-1.21-10.67-1.21-10.67l-2.78-17.28c-4.43,14.66-10.06,32.32-11.93,33.6a5.81,5.81,0,0,0-2.82,5.23c2.62,3.23,1.61,17.14,1.61,17.14s0,38.48-1.89,41.11S869.09,754,869.09,754s10.8,9.61,2.3,14.46l-.09,0c-8.67,4.84-26.6-8.66-26.6-8.66l1.87-1.87.55-.55L845,754.22c-2.08-3.63,6.08-10.48,6.08-10.48s-2.18-8.47-1.38-8.87,1.38-8.06,1.38-8.06-2-27.81-1.18-30.43a4.1,4.1,0,0,0-1-3.47,8.63,8.63,0,0,1-1.54-5.4,6.42,6.42,0,0,0-1.33-4.63c-2.42-2.62,0-13.9,0-13.9l2-14.92V630.37A37.77,37.77,0,0,1,850.56,617a40,40,0,0,0,2.2-10.73c.66-7.64,4.77-15.06,7.53-19.29,1.46-2.24,2.55-3.58,2.55-3.58l64.48-2.52s1,2.87,2.08,6.86c.22.87.44,1.79.65,2.75,1.35,6.2,2.16,13.88-.57,18.2a16.93,16.93,0,0,0-1,1.82c-3.69,7.86-1.17,17.73-1.17,17.73s-3.22,22.36-4.63,26c-1,2.57-.08,6.16.55,8a9.1,9.1,0,0,1,.45,2.79V673s1.62,6.65.81,8.47S925.91,688.32,925.91,688.32Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M928.88,609.33a15.3,15.3,0,0,0-1,1.81l-3.63-.2c.35-1.87-2.12-19.4-2.12-19.4l7.31-.41C930.79,597.32,931.61,605,928.88,609.33Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M929.48,608.72a16.93,16.93,0,0,0-1,1.82l-3.63-.21c.35-1.86-2.12-19.4-2.12-19.4l7.31-.41C931.4,596.72,932.21,604.4,929.48,608.72Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M929.48,608.72a16.93,16.93,0,0,0-1,1.82l-3.63-.21c.35-1.86-2.12-19.4-2.12-19.4l7.31-.41C931.4,596.72,932.21,604.4,929.48,608.72Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.05
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M918.8,772.34a2.44,2.44,0,0,1-1.15,1c-2.7,1.14-12.68-3.92-18.36-7a3.27,3.27,0,0,1-1.51-1.8c3.24-.59,5.36,3,5.36,3a4.78,4.78,0,0,1,6.65,1.61c2.77,4.08,8.71,2.36,8.71,2.36Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M920.47,784.69c-.6,1.82-5.14,1.82-5.14,1.82s-8.11,2.32-11.74,4.13-6.09.86-6.09.86c-8.31,1.91-19-1.41-22.22-2.07s-4.48-4.83-.5-5.64a8.06,8.06,0,0,0,1.49-.46,12.16,12.16,0,0,0,5-4,102.27,102.27,0,0,1,8.49-7.31,24.82,24.82,0,0,0,5.32-5.39c4.74-4.18,8.11,1.56,8.11,1.56a4.78,4.78,0,0,1,6.65,1.62c2.77,4.08,8.71,2.35,8.71,2.35s1.07,2.73,1.57,4.69c.12.5.25,1.12.37,1.82C920.76,780.7,920.93,783.33,920.47,784.69Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#ff748f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 820.29,
    cy: 713.38,
    r: 0.55,
    fill: "#575988"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.56,
    cy: 717.81,
    r: 0.55,
    fill: "#575988"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.75,
    cy: 721.79,
    r: 0.55,
    fill: "#575988"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.24,
    cy: 720.01,
    r: 0.55,
    fill: "#575988"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.03,
    cy: 715.46,
    r: 0.55,
    fill: "#575988"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M920.47,784.69c-.6,1.82-5.14,1.82-5.14,1.82s-8.11,2.32-11.74,4.13-6.09.86-6.09.86c-8.31,1.91-19-1.41-22.22-2.07s-4.48-4.83-.5-5.64a8.06,8.06,0,0,0,1.49-.46,38.68,38.68,0,0,0,10.9,2.07c8.21.35,14.71,0,14.71,0l8.31-2.67a13.89,13.89,0,0,1,5.14-1.86,13.44,13.44,0,0,0,5.11-2.22C920.76,780.7,920.93,783.33,920.47,784.69Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#dce6f2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M899.79,789.9a6.88,6.88,0,0,1-1.38-.13l.12-.59a8.8,8.8,0,0,0,5-.7c.74-.29,1.48-.64,2.2-1s1.73-.81,2.63-1.14l.82-.28c.45-.16.91-.31,1.35-.5.25-.1.5-.22.74-.34a8.51,8.51,0,0,1,1.86-.71,9.18,9.18,0,0,1,1-.13,8.9,8.9,0,0,0,.92-.11,8.65,8.65,0,0,0,1.75-.65,8.46,8.46,0,0,1,1.88-.7l.44-.07a2.15,2.15,0,0,0,1.3-.48l.45.41a2.71,2.71,0,0,1-1.65.67l-.42.07a8.09,8.09,0,0,0-1.75.65,9.17,9.17,0,0,1-1.88.69,6.69,6.69,0,0,1-1,.12,8.92,8.92,0,0,0-.94.12,8,8,0,0,0-1.73.67l-.76.35c-.46.19-.94.35-1.4.51l-.8.28c-.88.32-1.74.73-2.58,1.12s-1.48.7-2.24,1A10.91,10.91,0,0,1,899.79,789.9Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#575988",
    opacity: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M901.73,689.78s4.18-6,11.34-6,10.22-.81,10.22-.81-4.58,2.72-7.75,3.07S901.73,689.78,901.73,689.78Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M904.15,691.19s3.78-2.62,5.94-2.72,4-.3,4-.3a11.56,11.56,0,0,1-3.32,1.61C909,690.28,904.15,691.19,904.15,691.19Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M905,693s5.69.45,5.74,2",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M851.93,608c.3.05,5.39-5.29,5.74-7.4a5.17,5.17,0,0,1,2.21-3.26s3.28,1.31.36,5.33S851.93,608,851.93,608Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M930,435.21c-1.16,2.74-2.18,3-2,5.61a20,20,0,0,1-4.61,3.63c-3.6,2.14-7.52,6.33-12,6.33a23.91,23.91,0,0,1-8.77-1.66c-.72-5.69-2.86-8.16-2.86-8.16S935.28,422.78,930,435.21Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M935.44,425.54a24,24,0,1,1-24-24A24,24,0,0,1,935.44,425.54Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#cc818c"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M937,460.91l-7.71,11.48s-36.43,17.38-29.47-3c3.06-9,3.42-15.57,2.87-20.12l.06,0a19.27,19.27,0,0,1,.73,4.63c.11,3.14.19,7.11,8,8.42,13,2.18,19.94-5.94,21.16-7.53A37.71,37.71,0,0,0,937,460.91Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M783.61,412.17l-4.83,9.37a19,19,0,0,1-4.49-.94l-.42-.5c2,.76,8.61-11.79,8.61-11.79l.21.17C783.27,410.67,783.61,412.17,783.61,412.17Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M929.4,587.77c-15.56,6.76-69.38,1-69.38,1a7.37,7.37,0,0,0,.27-1.76c1.46-2.24,2.55-3.58,2.55-3.58l64.48-2.52S928.37,583.78,929.4,587.77Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M902.71,449.83l-7.18,3.07a5.69,5.69,0,0,1-5.13-3.33c-1.67-3.47-7.56,0-7.56,0s-18-1.36-24.64,2c0,0-10.73-4.54-12.24-4.84s-3.78-1.51-4.84-1.21-2.41-2-3.17-1.81-1.06-1.51-3.48-2.12-3.32.15-6-2.57-24.79-13.45-24.79-13.45l-10-8.16-10.58-8.46s-6.65,12.54-8.62,11.78l20.1,24.19s14.51,12.69,24.49,16.77,9.22,5.29,9.22,5.29,30.23,15.42,34.91,15.12S867,513.65,865,518.79s-5.13,42.32-5.13,42.32-3,7.86.15,13.3c0,0,.75,11.19,0,13.15,0,0,54.15,5.79,69.52-1.06,0,0,2.27-25.09,0-28.26S931.66,548,931.66,548l9.67-21.61,23.58-23.73s3.62-19.8-12.55-32.49l-10.73-9.53s-6-5.19-7.76-5.52-1.11,0-1.11,0-7,10.21-21.36,7.79c-7.78-1.31-7.86-5.28-8-8.41A19.6,19.6,0,0,0,902.71,449.83Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#67647e"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M932.26,531.19S899,532.55,892.36,543c0,0,8.62-4.09,16.32-2.88S932.26,531.19,932.26,531.19Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M895.53,567.61s15.72,1.06,19.05-2.27,3.34-5.29,3.34-5.29Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M935.44,499.14s-13.31,15.72,2.87,22.52Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M856.69,468.77s4.84,9.87,7.26,10.52Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M840.37,464.53s12.09,10.89,14.36,11.94C854.73,476.47,842.18,464.53,840.37,464.53Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M888.58,454.11s-11.64,17.38-4.08,28C884.5,482.07,880.27,469.52,888.58,454.11Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M917.92,585.75l-3.56,3.35-.5.46-4.12,3.9c-.29.22-.58.44-.88.64-16.77,12-20.13-6.24-20.13-6.24s-7.4,4.84-8.46.91,17.23-9.52,20-9.22a3.59,3.59,0,0,0,.73,0,11.44,11.44,0,0,0,3.76-1.33l.81-.43a32,32,0,0,0,2.71-1.71Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#cc818c"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M936,425.54A24,24,0,0,1,924.3,446.2a13.64,13.64,0,0,1-.88-1.75c-.86-2-1.39-4.16-2.26-6.17a19,19,0,0,0-4-5.88,2.55,2.55,0,0,0-1.07-.74,2.88,2.88,0,0,0-2.2.61,10.11,10.11,0,0,1-3.35,1.47,3.56,3.56,0,0,1-3.36-1c-.94-1.12-.81-2.76-.54-4.19.59-3.13,1.57-6.21,1.58-9.39s-1.21-6.6-4-8.18c-2.44-1.39-5.47-1-8.18-1.78a8.92,8.92,0,0,1-1.23-.42A24,24,0,0,1,936,425.54Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M893.17,404.94c-.43.23-.91.65-.78,1.13a1.14,1.14,0,0,0,.44.56,10.49,10.49,0,0,0,3.8,1.95c2.71.74,5.75.39,8.19,1.78,2.76,1.57,4,5,4,8.18s-1,6.26-1.57,9.38c-.27,1.44-.41,3.08.53,4.2a3.59,3.59,0,0,0,3.36,1,10,10,0,0,0,3.35-1.46,2.91,2.91,0,0,1,2.21-.62,2.72,2.72,0,0,1,1.07.74,19,19,0,0,1,4,5.89c.88,2,1.4,4.15,2.26,6.17a10,10,0,0,0,4,5c1.92,1.06,4.58,1,6.06-.64s1.36-3.89,2.06-5.86c1.2-3.43,4.55-5.58,6.65-8.54,2.35-3.33,3-7.51,3.64-11.54a9.48,9.48,0,0,0,.06-3.86,13.86,13.86,0,0,0-1.06-2.44c-2.34-4.84-2.29-10.93-6-14.79-2.8-2.9-7.05-3.78-11.05-4.28s-8.2-.78-11.63-2.89a12.65,12.65,0,0,0-3.15-1.74,2.58,2.58,0,0,0-3.1,1.16,2.06,2.06,0,0,1-.41.84,1.33,1.33,0,0,1-1.19.07l-5.32-1.43.61,2.68a13.32,13.32,0,0,1-5.65-1c-.1,1.52,1.61,2.5,2.14,3.92a3.63,3.63,0,0,1-1,3.68C897.76,404.12,895.35,403.75,893.17,404.94Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#585268"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M871.61,766.06l-.22,2.41-.09,0c-8.67,4.84-26.6-8.66-26.6-8.66l1.87-1.87a3.26,3.26,0,0,1,.82,2.53l3.66.2,4.38,4.73s11.85,1.37,15.06.61Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M870.09,779.2c-5.64,1.26-25.39,1.17-25.39,1.17l-11.08,1.75s-19,1.82-21.11-4.08,1.66-5.53,1.66-5.53l.15,0,7.91-.64s10-3.88,13.71-6.55a79.6,79.6,0,0,0,8.21-7.36s3.3-.64,3.24,3.18l3.66.2,4.38,4.74s11.85,1.37,15.06.6h1.12l-.51,5.85.14.17C872,773.62,875.13,778.08,870.09,779.2Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#ff748f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.32,
    cy: 706.52,
    r: 0.55,
    fill: "#575988"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.11,
    cy: 712.68,
    r: 0.55,
    fill: "#575988"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.79,
    cy: 714.9,
    r: 0.55,
    fill: "#575988"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.84,
    cy: 711.5,
    r: 0.55,
    fill: "#575988"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.44,
    cy: 713.79,
    r: 0.55,
    fill: "#575988"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.61,
    cy: 709.75,
    r: 0.55,
    fill: "#575988"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.34,
    cy: 708.13,
    r: 0.55,
    fill: "#575988"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M870.09,779.2c-5.64,1.26-25.39,1.17-25.39,1.17l-11.08,1.75s-19,1.82-21.11-4.08,1.66-5.53,1.66-5.53l.15,0c1.21,1.57,3.64,3.35,8.41,3.44l13.66.55,14.15-1s13.26-.39,15.42-.85a31.59,31.59,0,0,0,5.28-1.94C872,773.62,875.13,778.08,870.09,779.2Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#dce6f2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M834.69,780.79a8.19,8.19,0,0,1-2.24-.28l.16-.58a11.1,11.1,0,0,0,5.62-.25c.67-.18,1.33-.37,2-.57a31.6,31.6,0,0,1,3.69-.93A30.57,30.57,0,0,1,850,778l.43,0a93.62,93.62,0,0,0,18.14-.81,6.79,6.79,0,0,0,3.88-1.56l.43.43a7.36,7.36,0,0,1-4.21,1.73,94.09,94.09,0,0,1-18.26.81l-.44,0a30.09,30.09,0,0,0-6,.18,29.79,29.79,0,0,0-3.61.91c-.67.2-1.34.4-2,.57A15.2,15.2,0,0,1,834.69,780.79Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#575988",
    opacity: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M917.92,585.75l-3.56,3.35-8.84-11.32a32,32,0,0,0,2.71-1.71Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M958,493l7,9.67v10.13s3.17,10.73,0,21.46l.34,9.37s-3.37,8.61-2.16,10.73c0,0-.6,6.35-8.76,10.73S937,579.85,937,579.85s-3.48,6.65-12.85,5.14l-8.92,3.78-10.27-13.15,13.9-7.56s4.84-6.49,7.71-6.19l11.79-13.76s.3-4.38,3.32-4.38c0,0-5.59-4.53-3.63-7.25s.31-14.82.31-14.82Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#67647e"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M945,537.08s15.87-.3,17.83,3.78S949.79,534.81,945,537.08Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M913.93,588.77a4.15,4.15,0,0,1-.07.79,5.34,5.34,0,0,1-5,4.54h-.28a5.34,5.34,0,0,1-5.34-5.34,5.2,5.2,0,0,1,.3-1.73c-2.52-2-2.66-5.68-2.59-7.5a11.44,11.44,0,0,0,3.76-1.33,24.88,24.88,0,0,0,2.63,5.37,5.61,5.61,0,0,1,1.24-.15A5.35,5.35,0,0,1,913.93,588.77Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M905.19,577s-3.58.81-3.58,1.46-.81,6.55,3.12,9,3.53-3.38,3.53-3.38S904.88,578.9,905.19,577Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#575988"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.86,
    cy: 530.75,
    r: 5.34,
    fill: "#e4aab4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.86,
    cy: 530.75,
    r: 4.58,
    fill: "#dce6f2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M888.38,590.84s11.29,9.36,25.79,3.42v4.54s-9.67,6.65-18.43,2.62S888.38,590.84,888.38,590.84Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M888.38,589.63s11.29,9.37,25.79,3.42v4.54s-9.67,6.65-18.43,2.62S888.38,589.63,888.38,589.63Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M888.38,589.63s11.29,9.37,25.79,3.42v4.54s-9.67,6.65-18.43,2.62S888.38,589.63,888.38,589.63Z",
    transform: "translate(-86.32 -58.02)",
    fill: "#444053"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M888.68,589.63s11.29,9.37,25.8,3.42v4.54s-9.67,6.65-18.44,2.62S888.68,589.63,888.68,589.63Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.05
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M852.91,757.94s15.12,2.78,17.33,3.38-.6,1.66-.6,1.66S855.84,760.51,852.91,757.94Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M852.56,749.93c.25,0,10.28-2.82,12.44-7.65",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M867.19,692.1s4.06,5.34,6.68,5.19S869.57,691.9,867.19,692.1Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M869.44,701s1.71,3.77,4.23,2.56",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M879,618l10.72,28.27s1.51-18.19-1.68-23.63A9.43,9.43,0,0,0,879,618Z",
    transform: "translate(-86.32 -58.02)",
    opacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.34,394l-.09-.41-1.72-.46.19.84A14.6,14.6,0,0,0,905.34,394Z",
    transform: "translate(-86.32 -58.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.61,400.82l.18-.16a3.62,3.62,0,0,0,1-3.68,4.85,4.85,0,0,0-.86-1.37,14.13,14.13,0,0,1-2.48-.73c-.1,1.51,1.6,2.49,2.13,3.91A3,3,0,0,1,900.61,400.82Z",
    transform: "translate(-86.32 -58.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.2,447.29a10,10,0,0,1-4.05-5c-.85-2-1.38-4.16-2.25-6.16a19,19,0,0,0-4-5.89,2.62,2.62,0,0,0-1.07-.74,2.92,2.92,0,0,0-2.2.61,10.11,10.11,0,0,1-3.35,1.47,3.58,3.58,0,0,1-3.36-1c-.94-1.12-.81-2.77-.54-4.2.59-3.12,1.57-6.21,1.58-9.38s-1.21-6.61-4-8.18c-2.44-1.39-5.47-1-8.18-1.78a10.53,10.53,0,0,1-3.81-1.95,1.8,1.8,0,0,1-.2-.19,5,5,0,0,0-.66.31c-.44.23-.91.65-.79,1.13a1.22,1.22,0,0,0,.45.56,10.41,10.41,0,0,0,3.8,1.95c2.71.74,5.74.39,8.18,1.78,2.76,1.57,4,5,4,8.18s-1,6.26-1.58,9.38c-.27,1.44-.4,3.08.54,4.2a3.58,3.58,0,0,0,3.36,1,10,10,0,0,0,3.35-1.46,2.89,2.89,0,0,1,2.2-.62,2.65,2.65,0,0,1,1.07.74,19.21,19.21,0,0,1,4,5.89c.88,2,1.4,4.15,2.26,6.17a10,10,0,0,0,4,5c1.91,1.06,4.58,1,6-.64a4.7,4.7,0,0,0,.9-1.52A5.16,5.16,0,0,1,929.2,447.29Z",
    transform: "translate(-86.32 -58.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.84,439.6c1.51-1.91,3.5-3.54,4.92-5.54.28-.4.54-.82.78-1.24C941.71,435.15,939.2,437,937.84,439.6Z",
    transform: "translate(-86.32 -58.02)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEstimate);
export default __webpack_public_path__ + "static/media/create-estimate.7aad8d9b29769f847de83e327d2096c3.svg";
export { ForwardRef as ReactComponent };